module.exports = __webpack_public_path__ + "static/media/oven.c30deaa9.svg";